import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';
import { ImageCropperComponent } from 'ngx-image-cropper';

import { RealizarVistoriaComponent } from './components/realizar-vistoria.component';
import { CamposRelatorioVistoriaComponent } from './components/campos-relatorio-vistoria/campos-relatorio-vistoria.component';
import { ComodosVistoriaComponent } from './components/comodos-vistoria/comodos-vistoria.component';
import { ItensComodoVistoriaComponent } from './components/itens-comodo-vistoria/itens-comodo-vistoria.component';
import { DialogRecorteFotoComponent } from './components/dialog-recorte-foto/dialog-recorte-foto.component';
import { VistoriaSharedModule } from '../shared/vistoria-shared.module';

@NgModule({
  declarations: [
    RealizarVistoriaComponent,
    CamposRelatorioVistoriaComponent,
    ComodosVistoriaComponent,
    ItensComodoVistoriaComponent,
    DialogRecorteFotoComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
    VistoriaSharedModule,
    ImageCropperComponent,
  ],
})
export class RealizarVistoriaModule { }
